import { render, staticRenderFns } from "./PersonnelMatter.vue?vue&type=template&id=3b73bbaf"
import script from "./PersonnelMatter.vue?vue&type=script&lang=js"
export * from "./PersonnelMatter.vue?vue&type=script&lang=js"
import style0 from "./PersonnelMatter.vue?vue&type=style&index=0&id=3b73bbaf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports